import * as React from 'react';

import styles from './field-mapping-card.module.css';

export type EntityName = 'CONTACT' | 'ACCOUNT' | 'LEAD';

type Props = {
    icon: React.ReactElement<any>;
    title: string | null | undefined;
    subtitle?: string | null | undefined;
    actionItem?: React.ReactNode;
};

export function MappingCardStatus(props: Props) {
    return (
        <div className={styles['status-container']}>
            <div className='flex align-center'>
                {props.icon}
                <div className={styles.status}>
                    <div className={styles.title}>{props.title}</div>
                    {props.subtitle ? (
                        <div className={styles.subtitle}>{props.subtitle}</div>
                    ) : undefined}
                </div>
            </div>
            {props.actionItem}
        </div>
    );
}
